import * as Yup from 'yup'

export const initialValues = {
    description: '',
    make: '',
    model: '',
    shipToAccountId: '',
    neededByDate: new Date(),
    quantity: 1,
}

export const validationSchema = Yup.object().shape({
    description: Yup.string()
        .required('This description is required')
        .max(255, 'Description too long (maximum 255 characters)'),
    make: Yup.string().required('This Make is required'),
    model: Yup.string().required('This Model is required'),
    neededByDate: Yup.string().required('This Date is required'),
    quantity: Yup.string().required('This quantity is required'),
    shipToAccountId: Yup.string().required('This location is required'),
})
